// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3UKTm","headline-link":"MpbFi","image-link":"PVbKv"};